import { DateTime } from 'luxon'

export default {
  data () {
    return {
      statusStages: [
        { key: 'appliedOn', label: 'Applied', status: 'Applied' },
        { key: 'reviewedOn', label: 'Reviewed', status: 'Reviewed' },
        { key: 'interviewScheduledOn', label: 'Interview', status: 'Interview Scheduled' },
        { key: 'interviewedOn', label: 'Interviewed', status: 'Interview Done' },
        { key: 'offeredOn', label: 'Job Offer', status: 'Job Offered' },
        { key: 'acceptedOn', label: 'Job Acceptance', status: 'Job Accepted' }
      ]
    }
  },
  methods: {
    parseDateTime (value) {
      if (value === undefined || value === null || value === '') {
        return null
      }
      if (typeof value === 'number') {
        return DateTime.fromMillis(value < 1e12 ? value * 1000 : value)
      }
      if (value instanceof Date) {
        return DateTime.fromJSDate(value)
      }
      if (typeof value === 'object') {
        return this.parseDateTime(value.epochMillis || value.millis || value.time || value.epochSecond)
      }
      let text = String(value).trim()
      if (!text) {
        return null
      }
      let parsed = DateTime.fromISO(text)
      if (parsed.isValid) {
        return parsed
      }
      parsed = DateTime.fromFormat(text, 'MM/dd/yyyy')
      if (parsed.isValid) {
        return parsed
      }
      parsed = DateTime.fromFormat(text, 'yyyy-MM-dd HH:mm:ss')
      if (parsed.isValid) {
        return parsed
      }
      let asNumber = Number(text)
      if (!isNaN(asNumber)) {
        return this.parseDateTime(asNumber)
      }
      return parsed
    },
    millisToDate (millis) {
      let parsed = this.parseDateTime(millis)
      return parsed && parsed.isValid ? parsed.toFormat('MM/dd/yyyy') : this.$t('na')
    },
    applyByLabel (applyBy) {
      let value = applyBy
      if (value && typeof value === 'object') {
        value = value.epochMillis || value.millis || value.time || value.epochSecond
      }
      if (!value || Number(value) === 0) {
        return this.$t('untilFilled')
      }
      return this.millisToDate(value)
    },
    applicationDate (application) {
      if (!application) {
        return null
      }
      return application.creationTime || application.appliedTime || application.statusUpdatedTime || application.lastUpdatedTime
    },
    stageDateValue (application, stage) {
      if (!application || !stage) {
        return null
      }
      if (stage.key === 'acceptedOn' && this.isOfferDeclined(application)) {
        return application.declinedOn || application.statusUpdatedTime || application.lastUpdatedTime
      }
      let value = application[stage.key]
      if (stage.key === 'appliedOn' && !value) {
        value = this.applicationDate(application)
      }
      if (stage.key === 'offeredOn' && !value) {
        value = application.jobOfferedOn || application.offerDate || application.statusUpdatedTime || application.lastUpdatedTime
      }
      return value
    },
    stageDateLabel (application, stage) {
      if (!this.isStageComplete(application, stage) && !this.isStageRejected(application, stage)) {
        return this.$t('na')
      }
      return this.millisToDate(this.stageDateValue(application, stage))
    },
    statusRank (status) {
      if (status === 'Accepted') {
        status = 'Job Accepted'
      }
      if (status === 'Offered' || status === 'Job Offer') {
        status = 'Job Offered'
      }
      if (status === 'Declined') {
        return this.statusRank('Job Offered')
      }
      let order = ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted']
      let index = order.indexOf(status)
      return index < 0 ? 0 : index
    },
    isOfferAccepted (application) {
      if (!application) {
        return false
      }
      return !!(application.acceptedOn || application.status === 'Accepted' || application.status === 'Job Accepted')
    },
    isOfferDeclined (application) {
      if (!application) {
        return false
      }
      return !!(application.declinedOn || application.status === 'Declined' || application.acceptedRejected || application.acceptanceStatus === 'Rejected' || application.acceptanceStatus === 'Declined')
    },
    isStageRejected (application, stage) {
      if (!application || !stage) {
        return false
      }
      if (stage.key === 'interviewScheduledOn') {
        return !!(application.interviewRejected || application.interviewScheduleStatus === 'Rejected')
      }
      if (stage.key === 'offeredOn') {
        return !!(application.offerRejected || application.offerStatus === 'Rejected')
      }
      if (stage.key === 'acceptedOn') {
        return this.isOfferDeclined(application)
      }
      return false
    },
    isStageComplete (application, stage) {
      if (!application || !stage) {
        return false
      }
      if (this.isStageRejected(application, stage)) {
        return false
      }
      if (stage.key === 'acceptedOn') {
        return this.isOfferAccepted(application)
      }
      if (application[stage.key]) {
        return true
      }
      return this.statusRank(application.status) >= this.statusRank(stage.status)
    },
    canRespondToOffer (application, stage) {
      if (!application || !stage || stage.key !== 'acceptedOn') {
        return false
      }
      if (this.isOfferAccepted(application) || this.isOfferDeclined(application)) {
        return false
      }
      return application.status === 'Job Offered' || this.statusRank(application.status) >= this.statusRank('Job Offered')
    },
    stageDisplayLabel (application, stage) {
      if (!stage) {
        return ''
      }
      if (stage.key === 'acceptedOn' && this.isOfferDeclined(application)) {
        return this.$t('declined')
      }
      if (stage.key === 'acceptedOn' && this.isOfferAccepted(application)) {
        return this.$t('accepted')
      }
      return stage.label
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/job/jobApplicationStatus.js